import { mountLegislature } from './utils/mount-legislature.js';
import { STATE_URL } from './constants.js';
import { called_senate_races } from './close_races.js';
mountLegislature(
  'uncalled-california-state-senate',
  STATE_URL,
  'Z',
  called_senate_races
).catch(console.error);
